import classnames from 'classnames';
import PropTypes from 'prop-types';
import qs from 'qs';
import { Component } from 'react';
import { Button } from 'react-bootstrap';
import { FREE_PLAN_NAME } from '../../../../shared/subscriptions';

import { window } from '../../../globals';
import type { IssueType, Project, Revision, RevisionScan } from '../../../types';
import { getProjectBaseURLFromParams, isAuthed, isProjectInCurrentOrg } from '../../../utils';
import Flex from '../../generic/Flex';
import Icon, { icons } from '../../generic/Icon';
import type { RevisionRouteParams } from '../projectDashboardTypes';
import ISSUE_INDEX from './IssueIndex';
import { CATEGORY_TO_ISSUE_TYPES, Category } from '../../../../shared/issuesV2';

class IssueListItem extends Component<{
  issueType: IssueType;
  count: number;
  revision: Revision;
  project: Project;
  selectedRevisionScan?: RevisionScan;
  params: RevisionRouteParams;
  onClick?: Function;
}, {
  expanded: boolean;
}> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  static propTypes = {
    onClick: PropTypes.func,
    revision: PropTypes.object,
    project: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }

  onExpand = () => {
    this.setState((state) => ({ expanded: !state.expanded }));
  };

  onItemClick = () => {
    if (!isAuthed()) {
      return window.showPlanSelectorModal({ tier: FREE_PLAN_NAME });
    }
    if (!isProjectInCurrentOrg(this.props.project.organizationId)) {
      return;
    }

    const params: Record<string, unknown> = {};

    // filter down to specific revision scan if applicable
    if (this.props.selectedRevisionScan) {
      params.revScanId = this.props.selectedRevisionScan.id;
    }
    // choose page and query params based on issue type
    let issueDashPage;
    if (this.props.issueType === 'vulnerability') {
      issueDashPage = 'vulnerability';
    } else if (CATEGORY_TO_ISSUE_TYPES[Category.Quality].includes(this.props.issueType)) {
      issueDashPage = 'quality';
    } else {
      issueDashPage = `licensing`;
      params.filter = {
        type: [this.props.issueType],
      };
    }

    // build path from selected issue page and search params from provided query params
    const issueDashPath = `${getProjectBaseURLFromParams(this.props.params)}/issues/${issueDashPage}`;

    // redirect to issues page with relevant issues selected
    const issueDashURL = `${issueDashPath}?${qs.stringify(params)}`;
    this.context.router.push(issueDashURL);
  };

  render() {
    const { count, issueType, project } = this.props;
    if (!count) {
      return null;
    }

    const issueInfo = ISSUE_INDEX[this.props.issueType] || {
      title: 'Issue',
    };

    const listItemClassName = classnames('issue-list-item', 'upshadow', {
      expanded: this.state.expanded,
    });

    return (
      <li
        className={listItemClassName}
        onClick={this.onItemClick}
      >
        <span className="icon-circle" />
        <Flex align="center" justify="space-between">
          <h4>
            {count}{' '}
            {issueInfo.title || issueType}
          </h4>
          <div className="text-right">
            {!isProjectInCurrentOrg(project.organizationId) ? (
              <Button
                bsStyle="default"
                disabled
              >
                <Icon icon={icons.lock} /> Maintainer Access Required
              </Button>
            ) : (
              <Button bsStyle="default">
                <Icon icon={icons.reviewFix} /><span className="margin-left-xs full">Review & Fix</span>
              </Button>
            )}
            <span className="margin-left-xs">
              <Icon icon={icons.chevronDown} />
            </span>
          </div>
        </Flex>
        <p>
          {ISSUE_INDEX[issueType].description}
        </p>
      </li>
    );
  }
}

export default IssueListItem;
